const removewhitespace =  /[^a-zA-Z0-9]/g  ;

export {
    removewhitespace
}